if (!customElements.get("pcard-swatch")) {
  class ProductCardColorSwatch extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-pcard-variant-picker]",
        optionNodes: [".m-product-option--node__label"],
        featuredImage: ".m-product-card__main-image",
        pcard: ".m-product-card",
        variantDropdown: ".m-product-option--dropdown-select",
        priceWrapper: ".m-price",
        salePrice: ".m-price-item--sale",
        compareAtPrice: [".m-price-item--regular"],
        discountBadge: "[data-variant-discount-badge]",
        variantSaleBadge: "[data-variant-sale-badge]",
        unitPrice: ".m-price__unit",
        soldOutBadge: ".m-product-tag--soldout",
      };

      this.container = this.closest(this.selectors.container);
      this.pcard = this.closest(this.selectors.pcard);
      this.variantIdNode = this.pcard && this.pcard.querySelector('[name="id"]');
      this.featuredImage = this.pcard && this.pcard.querySelector(this.selectors.featuredImage);
      this.keepFeaturedImage = this.dataset.keepFeaturedImage === "true";
      this.domNodes = queryDomNodes(this.selectors, this.pcard);

      this.initializeData();
    }

    async initializeData() {
  this.variantData = this.fetchVariantData();
  this.productHandle = this.container.dataset.productHandle;
  this.activeOptionNodeByPosition = {};
  this.hideUnavailableProductOptions = MinimogSettings.hide_unavailable_product_options;

  // Використовуємо дані з DOM замість fetch
  const variants = Array.isArray(this.variantData) ? this.variantData : [];
  this.productData = {
    variants: variants,
    selected_or_first_available_variant: variants.find(v => v.available) || variants[0],
  };

  const {
    variantIdNode,
    productData,
    productData: { variants: productVariants } = {},
  } = this;

  if (productData) {
    let currentVariantId = variantIdNode && Number(variantIdNode.value);

    if (!currentVariantId) {
      currentVariantId =
        productData.selected_or_first_available_variant &&
        productData.selected_or_first_available_variant.id;
    }

    const currentVariant = productVariants.find((v) => v.id === currentVariantId) || productVariants[0];
    this.productData.initialVariant = currentVariant;

    if (!this.productData.selected_variant && variantIdNode && variantIdNode.dataset.selectedVariant) {
      this.productData.selected_variant = productVariants.find(
        (v) => v.id === Number(variantIdNode.dataset.selectedVariant)
      );
    }

    if (!this.keepFeaturedImage) {
      this.updateOptionsByVariant(currentVariant);
      this.updateProductImage(currentVariant);

      window.MinimogEvents.subscribe("m:image-loaded", () => {
        this.updateProductImage(currentVariant);
      });
    }
  }

  if (this.domNodes.optionNodes) {
    this.domNodes.optionNodes.forEach((node) =>
      node.addEventListener("click", this.handleVariantSelection.bind(this))
    );
  }

  if (this.domNodes.variantDropdown) {
    this.domNodes.variantDropdown.addEventListener("change", this.handleVariantSelection.bind(this));
  }
}

    fetchVariantData() {
      if (!this.variantData) {
        const jsonElement = this.container && this.container.querySelector('[type="application/json"]');
        this.variantData = JSON.parse(jsonElement ? jsonElement.textContent : "{}");
      }
      return this.variantData;
    }



    toggleOptionNodeActive(optNode, active) {
      if (!optNode) return;

      if (active) {
        const { optionPosition, value: optionValue } = optNode.dataset;
        this.activeOptionNodeByPosition[optionPosition] = optNode;

        switch (optNode.tagName) {
          case "INPUT":
            optNode.checked = true;
            optNode.dataset.selected = "true";
            break;

          case "OPTION":
            optNode.dataset.selected = "true";
            {
              const select = optNode.closest("select");
              if (select) select.value = optNode.value;
            }
            break;

          case "LABEL":
            optNode.dataset.selected = "true";
            break;

          default:
            if (!optNode.classList.contains("m-product-quickview-button")) {
              console.warn("Unable to activate option node", optNode);
            }
            break;
        }

        this.updateSoldOutBadge(this.getVariantsByOptionValue(optionValue));
      } else {
        if (!["default", "image", "color", "swatch_color"].includes(optNode.dataset.optionType)) {
          optNode.style.border = "";
        }

        optNode.checked = false;
        delete optNode.dataset.selected;

        const select = optNode.closest("select");
        if (select) select.value = "";
      }
    }

    updateOptionsByVariant(variant) {
      Object.values(this.activeOptionNodeByPosition).forEach((optNode) =>
        this.toggleOptionNodeActive(optNode, false)
      );

      const { optionNodes } = this.domNodes;
      const { options = [] } = variant || {};

      options.forEach((option, index) => {
        const optPosition = index + 1;

        optionNodes.forEach((optNode) => {
          const _optPosition = Number(optNode.dataset.optionPosition);
          const _optValue = optNode.dataset.value;

          if (_optPosition === optPosition && option === _optValue) {
            this.toggleOptionNodeActive(optNode, true);
          }
        });
      });

      this.updatePrice(variant);
    }

    getVariantFromActiveOptions = () => {
      const {
        productData,
        productData: { initialVariant },
        activeOptionNodeByPosition,
      } = this;

      const initialVariantOptions = {
        1: initialVariant.option1,
        2: initialVariant.option2,
        3: initialVariant.option3,
      };

      Object.values(activeOptionNodeByPosition).forEach((optNode) => {
        const { optionPosition, value } = optNode.dataset;
        initialVariantOptions[optionPosition] = value;
      });

      let options = Object.values(initialVariantOptions).filter(Boolean);
      let variant = getVariantFromOptionArray(productData, options);

      if (!variant && this.hideUnavailableProductOptions) {
        options.pop();
        variant = getVariantFromOptionArray(productData, options);

        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(productData, options);
        }
      }

      this.currentVariant = variant;
      return variant;
    };

    handleVariantSelection(e) {
      let target = e.target;
      let newVariant;

      if (target.classList.contains("combined-variant")) {
        const variantId = Number(e.target.value);
        newVariant =
          this.productData &&
          this.productData.variants &&
          this.productData.variants.find((v) => v.id === variantId);
      } else {
        if (target.tagName === "SELECT") {
          target = target.querySelectorAll("option")[target.selectedIndex];
        }

        if (!target.classList.contains("m-product-option--node__label")) {
          target = target.closest(".m-product-option--node__label");
          if (!target) {
            console.error("Unable to find option node!");
            return;
          }
        }

        const { optionPosition } = target.dataset;
        const currActiveOptNode = this.activeOptionNodeByPosition[optionPosition];

        this.toggleOptionNodeActive(currActiveOptNode, false);
        this.toggleOptionNodeActive(target, true);
        newVariant = this.getVariantFromActiveOptions();
      }

      if (!newVariant) return;

     const { variantIdNode } = this;
      if (variantIdNode) {
        variantIdNode.setAttribute("value", String(newVariant.id));
        variantIdNode.value = String(newVariant.id);
      }

      // Синхронізуємо input у формі Add to Bag
      if (this.pcard) {
        this.pcard.querySelectorAll('form.product-card-form input[name="id"]').forEach(input => {
          input.value = String(newVariant.id);
          input.setAttribute("value", String(newVariant.id));
        });
      }

      this.updateBySelectedVariant(newVariant);
    }

   updateBySelectedVariant(variant) {
  if (!variant) return;
  this.updateProductImage(variant);
  this.updatePrice(variant);
  this.updateAddToCartButton(variant);
}

updateAddToCartButton(variant) {
  if (!this.pcard) return;

  this.pcard.classList.toggle("m-product-card--soldout", !variant.available);

  const buttons = this.pcard.querySelectorAll('button.m-add-to-cart[name="add"]');

  buttons.forEach((btn) => {
    btn.disabled = !variant.available;
    if (variant.available) {
      btn.removeAttribute("disabled");
    } else {
      btn.setAttribute("disabled", "disabled");
    }

    const textEl = btn.querySelector("[data-atc-text]");
    if (textEl) {
      const text = variant.available
        ? btn.dataset.availableText
        : btn.dataset.soldOutText;
      if (text) textEl.textContent = text;
    }
  });
}

    updateProductCardSoldOutBadge(variant) {
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = variant.available ? "none" : "flex";
      }
    }

    updateSoldOutBadge(variants) {
      const soldOut = !variants.some((variant) => variant.available);
      if (this.domNodes.soldOutBadge) {
        this.domNodes.soldOutBadge.style.display = soldOut ? "flex" : "none";
      }
    }

    getVariantsByOptionValue = (value) => {
      const {
        productData: { variants } = {},
      } = this;
      return variants.filter((variant) => variant.options.includes(value));
    };

    updateProductImage(variant) {
      const src = variant && variant.featured_image && variant.featured_image.src;
      const { featuredImage } = this;
      const img = featuredImage && featuredImage.querySelector("img");

      if (img && src) {
        img.src = `${src}&width=533`;
        img.removeAttribute("srcset");
      }
    }

    updatePrice(variant) {
      if (MinimogSettings.pcard_show_lowest_prices) return;

      const classes = {
        onSale: "m-price--on-sale",
        soldOut: "m-price--sold-out",
      };

      const moneyFormat = window.MinimogSettings.money_format;
      const { priceWrapper, salePrice, unitPrice, compareAtPrice, discountBadge, variantSaleBadge } = this.domNodes;
      const { compare_at_price, price, unit_price_measurement } = variant;
      const onSale = compare_at_price && compare_at_price > price;
      const soldOut = !variant.available;
      const discountPercent = onSale ? Math.round(((compare_at_price - price) * 100) / compare_at_price) : 0;

      if (onSale) {
        priceWrapper && priceWrapper.classList.add(classes.onSale);
        this.pcard && this.pcard.classList.add("m-product-card--onsale");
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.onSale);
        this.pcard && this.pcard.classList.remove("m-product-card--onsale");
      }

      if (soldOut) {
        priceWrapper && priceWrapper.classList.add(classes.soldOut);
      } else {
        priceWrapper && priceWrapper.classList.remove(classes.soldOut);
      }

      priceWrapper && priceWrapper.classList.remove("visibility-hidden");

      if (salePrice) {
        salePrice.innerHTML = formatMoney(price, moneyFormat);
      }

      if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(compare_at_price, moneyFormat)));
      } else {
        compareAtPrice.forEach((item) => (item.innerHTML = formatMoney(price, moneyFormat)));
      }

      if (discountBadge) {
        discountBadge.hidden = !onSale;
        if (onSale) {
          discountBadge.textContent = `-${discountPercent}%`;
          discountBadge.setAttribute("aria-label", `${discountPercent}% off`);
        }
      }

      if (variantSaleBadge) {
        variantSaleBadge.hidden = !onSale;
        if (onSale && variantSaleBadge.dataset.saleBadgeMode === "show_percentage") {
          variantSaleBadge.textContent = `-${discountPercent}%`;
        }
      }

      if (unit_price_measurement && unitPrice && this.currentVariant) {
        unitPrice.classList.remove("f-hidden");
        const unitPriceContent = `<span>${formatMoney(
          this.currentVariant.unit_price,
          moneyFormat
        )}</span>/<span data-unit-price-base-unit>${this.getBaseUnit()}</span>`;
        unitPrice.innerHTML = unitPriceContent;
      } else {
        unitPrice && unitPrice.classList.add("f-hidden");
      }
    }

    getBaseUnit = () => {
      return this.currentVariant.unit_price_measurement.reference_value === 1
        ? this.currentVariant.unit_price_measurement.reference_unit
        : this.currentVariant.unit_price_measurement.reference_value +
            this.currentVariant.unit_price_measurement.reference_unit;
    };
  }

  customElements.define("pcard-swatch", ProductCardColorSwatch);
}

/* ===== CUSTOM SWATCH UX ===== */

(function () {
  const WRAPPER_SEL = ".lamel-card-swatches-wrapper";
const STRIP_SEL = ".lamel-card-swatches-viewport";
  const DOT_SEL = ".m-product-option--node__label.lamel-card-swatches__dot";
  const PREV_SEL = ".lamel-swatches-prev";
  const NEXT_SEL = ".lamel-swatches-next";

  const state = new WeakMap();
  let rafId = null;

  function getState(strip) {
    if (!state.has(strip)) {
      state.set(strip, {
        lockedValue: null,
        hoverValue: null,
        isDown: false,
        startX: 0,
        scrollLeft: 0,
      });
    }
    return state.get(strip);
  }

  function getSelectedValue(strip) {
    const selected = strip.querySelector(`${DOT_SEL}[data-selected="true"]`);
    return selected ? selected.dataset.value : null;
  }

  function ensureLocked(strip) {
    const s = getState(strip);
    if (!s.lockedValue) {
      s.lockedValue = getSelectedValue(strip);
    }
  }

  function findDotByValue(strip, value) {
    if (!strip || !value) return null;
    return strip.querySelector(`${DOT_SEL}[data-value="${CSS.escape(value)}"]`);
  }

  function clickDot(dot) {
    if (dot) dot.click();
  }

  function getStep(strip) {
    const track = strip.querySelector(".lamel-card-swatches-track");
    if (!track) return 96;

    const firstNode = track.querySelector(".m-product-option--node");
    if (!firstNode) return 96;

    const gap = parseFloat(getComputedStyle(track).columnGap) || parseFloat(getComputedStyle(track).gap) || 8;
    return firstNode.getBoundingClientRect().width + gap;
  }

  function updateNav(wrapper) {
    const strip = wrapper.querySelector(STRIP_SEL);
    const prev = wrapper.querySelector(PREV_SEL);
    const next = wrapper.querySelector(NEXT_SEL);
    if (!strip || !prev || !next) return;

    const hasOverflow = strip.scrollWidth > strip.clientWidth + 2;
    wrapper.classList.toggle("has-overflow", hasOverflow);

    if (!hasOverflow) {
      prev.classList.add("is-disabled");
      next.classList.add("is-disabled");
      return;
    }

    const atStart = strip.scrollLeft <= 2;
    const atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;

    prev.classList.toggle("is-disabled", atStart);
    next.classList.toggle("is-disabled", atEnd);
  }

  function updateEdgePadding(wrapper) {
    const strip = wrapper.querySelector(STRIP_SEL);
    const track = strip && strip.querySelector(".lamel-card-swatches-track");
    if (!strip || !track) return;

    const lastNode = track.querySelector(".m-product-option--node:last-child");
    if (!lastNode) return;

    if (!wrapper.classList.contains("has-overflow")) {
      track.style.paddingRight = "";
      return;
    }

    const extra = Math.max(0, strip.clientWidth * 0.25);
    track.style.paddingRight = `${extra + 6}px`;
  }

  function initWrapper(wrapper) {
    const strip = wrapper.querySelector(STRIP_SEL);
    const prev = wrapper.querySelector(PREV_SEL);
    const next = wrapper.querySelector(NEXT_SEL);

    if (!strip || !prev || !next) return;

    ensureLocked(strip);
    updateNav(wrapper);
    updateEdgePadding(wrapper);

    if (!wrapper.__lamelBound) {
      wrapper.__lamelBound = true;

      prev.addEventListener("click", () => {
        strip.scrollBy({ left: -getStep(strip), behavior: "smooth" });
        setTimeout(() => updateNav(wrapper), 250);
      });

      next.addEventListener("click", () => {
        strip.scrollBy({ left: getStep(strip), behavior: "smooth" });
        setTimeout(() => updateNav(wrapper), 250);
      });

      strip.addEventListener(
        "scroll",
        () => {
          updateNav(wrapper);
        },
        { passive: true }
      );

      strip.addEventListener("mousedown", (e) => {
        const s = getState(strip);
        s.isDown = true;
        s.startX = e.pageX - strip.offsetLeft;
        s.scrollLeft = strip.scrollLeft;
        strip.classList.add("is-dragging");
      });

      strip.addEventListener("mouseleave", () => {
        const s = getState(strip);
        s.isDown = false;
        strip.classList.remove("is-dragging");
      });

      strip.addEventListener("mouseup", () => {
        const s = getState(strip);
        s.isDown = false;
        strip.classList.remove("is-dragging");
      });

      strip.addEventListener("mousemove", (e) => {
        const s = getState(strip);
        if (!s.isDown) return;

        e.preventDefault();

        const x = e.pageX - strip.offsetLeft;
        const walk = (x - s.startX) * 1.5;
        strip.scrollLeft = s.scrollLeft - walk;
      });
    }
  }

  function reinitLamelSwatchesUI() {
    document.querySelectorAll(WRAPPER_SEL).forEach(initWrapper);
  }

  function queueReinit() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      reinitLamelSwatchesUI();
    });
  }

  function bindHoverDelegation() {
    if (document.__lamelHoverBound) return;
    document.__lamelHoverBound = true;

    document.addEventListener("mouseover", (e) => {
      const dot = e.target.closest(DOT_SEL);
      if (!dot) return;

      const strip = dot.closest(STRIP_SEL);
      if (!strip) return;

      const s = getState(strip);
      ensureLocked(strip);

      if (s.isDown) return;
      if (s.hoverValue === dot.dataset.value) return;

      s.hoverValue = dot.dataset.value;
      clickDot(dot);
    });

document.addEventListener("mouseleave", (e) => {
  if (!(e.target instanceof Element)) return;

  const strip = e.target.closest(STRIP_SEL);
  if (!strip) return;

  const s = getState(strip);
  if (s.isDown) return;

  s.hoverValue = null;

  if (s.lockedValue) {
    const lockedDot = findDotByValue(strip, s.lockedValue);
    clickDot(lockedDot);
  }
}, true);

    document.addEventListener("click", (e) => {
      const dot = e.target.closest(DOT_SEL);
      if (!dot) return;

      const strip = dot.closest(STRIP_SEL);
      if (!strip) return;

      const s = getState(strip);
      s.lockedValue = dot.dataset.value;
      s.hoverValue = null;
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    reinitLamelSwatchesUI();
    setTimeout(reinitLamelSwatchesUI, 200);
    setTimeout(reinitLamelSwatchesUI, 600);
    setTimeout(reinitLamelSwatchesUI, 1200);
    setTimeout(reinitLamelSwatchesUI, 1800);
  });

  window.addEventListener("load", reinitLamelSwatchesUI);
  window.addEventListener("resize", reinitLamelSwatchesUI);

  document.addEventListener("shopify:section:load", reinitLamelSwatchesUI);
  document.addEventListener("shopify:section:reorder", reinitLamelSwatchesUI);

  let pendingWrapperUpdates = new Set();
  let wrapperRafId = null;

  function queueWrapperUpdate(wrapper) {
    pendingWrapperUpdates.add(wrapper);
    if (wrapperRafId) cancelAnimationFrame(wrapperRafId);
    wrapperRafId = requestAnimationFrame(() => {
      pendingWrapperUpdates.forEach(initWrapper);
      pendingWrapperUpdates.clear();
    });
  }

  const lamelObserver = new MutationObserver((mutations) => {
    let matchedAny = false;
    mutations.forEach((m) => {
      const target = m.target;
      const wrapper = target && target.nodeType === 1 ? target.closest(WRAPPER_SEL) : null;
      if (wrapper) {
        matchedAny = true;
        queueWrapperUpdate(wrapper);
      }
    });
    // Якщо не вдалось точно визначити картку (напр. сам wrapper щойно додано/видалено) — безпечний повний перерахунок
    if (!matchedAny) {
      queueReinit();
    }
  });

document.querySelectorAll('[data-pcard-variant-picker]').forEach(el => {
  lamelObserver.observe(el, {
    childList: true,
    subtree: true,
  });
});
window.reinitLamelSwatchesUI = reinitLamelSwatchesUI;
  bindHoverDelegation();

})();
